import React, { useEffect, useState } from "react";
import { HandlesService } from '../../../core/services/handles.service';
import { UserService } from "../../../core/services";
import { connect } from 'react-redux';
import CommonPopUpCentered from "../../../components/popup/common-popup-centered";
import SocialConnectRestriction from "../../../components/popup/social-connect-restrict";
import { Link, matchPath, Navigate, Outlet, useLocation } from "react-router-dom";
import { Loading } from "../../../redux/action";
import { InstagramDMAutomation } from "../../../core/services/dm-automation-instagram.service";
import * as gtUtil from "../../../core/utility";
import { toast } from 'react-toastify';
import { UserLogin } from '../../../redux/action';
import ContentLoading from "../../../components/loader/loading";

const instagramDMAutomationService: InstagramDMAutomation = new InstagramDMAutomation();
const handlesService = new HandlesService();
const userService = new UserService();

interface Props {
  UserReducer: any;
  updateUser: any;
}

const InfluencerTools: React.FC<Props> = (props: Props) => {
  const location = useLocation();
  // Check if we are not on the new-automation path
  const isExactToolsPath = matchPath('/influencer/tools', location.pathname);
  
  const [popUps, setPopUps] = useState({
    openConnectInstagram: false,
    openAdditionalSettingsModal: false,
    openPermissionMissingModal: false
  });

  function handleClosePopUps() {
    setPopUps({
      openConnectInstagram: false,
      openAdditionalSettingsModal: false,
      openPermissionMissingModal: false
    })
  }

  const [loading, setLoading] = useState(false);
  const [social_loader, set_social_loader] = useState<boolean>(false);
  const [instgramAllPermissions, setInstgramAllPermissions] = useState(false)
  const [influencerAccounts, setInfluencerAccounts] = useState<any>([]);
  const [ig_data, set_ig_data] = useState({});
  const [socialRestrictionPopup, set_socialRestrictionPopup] = useState({
    // youtube: false,
    instagram: false
  });
  const [stateToUpdateUserReducer, setStateToUpdateUserReducer] = useState<boolean>(false);

  async function updateUserReducer() {
    let latestUserReducerData = await userService.getUpdatedUserReducer(props.UserReducer);
    if (![undefined, null, ''].includes(latestUserReducerData)) {
      props.updateUser(latestUserReducerData)
    }
    // if (props.stateToUpdateUserReducerfuntion) {
    //   props.stateToUpdateUserReducerfuntion(!stateToUpdateUserReducer);
    // }
    setStateToUpdateUserReducer(!stateToUpdateUserReducer);
  }

  const handleOpenConnectInstagramModal = () => {
    if (influencerAccounts?.length < 1) {
      setPopUps({...popUps, openConnectInstagram: true});
    } else if (!instgramAllPermissions) {
      setPopUps({...popUps, openPermissionMissingModal: true});
    } else {
      setPopUps({...popUps, openAdditionalSettingsModal: true});
    }
  }

  // Get all accounts of the influencer
  async function getInfluencerAccounts() {
    try {
      setLoading(true);
      const res = await instagramDMAutomationService.getInfluencerAccounts({
        influencer_id: props.UserReducer.influencer_id,
      });

      if (res.data.status === gtUtil.Constants.SUCCESS) {
        setInfluencerAccounts(res.data.rows);

        // Check permissions only if accounts are present
        if (res.data.rows.length > 0) {
          checkInstagramBusinessPermissions(res.data.rows[0]);
        }
      }
    } catch (error) {
      console.error("Error fetching getInfluencerAccounts:", error);
    } finally {
      setLoading(false);
    }
  }

  //Function to check all instagram permission are true or not
  function checkInstagramBusinessPermissions(data: any) {
    try {
      // Check if all required properties are true
      const instgramPermissions = 
      // JSON.parse(data?.instagram_business_basic) && JSON.parse(data?.instagram_business_manage_messages) && JSON.parse(data?.instagram_business_manage_comments)
      JSON.parse(data?.instagram_business_basic) && JSON.parse(data?.instagram_business_manage_comments)
      ? true
      : false;
      // const instgramPermissions = 
      // JSON.parse(data?.instagram_business_basic)
      // ? true
      // : false;
      if (instgramPermissions) {
        setInstgramAllPermissions(true);
      } else {
        setInstgramAllPermissions(false);
      }
    } catch (error) {
      console.log('error', error);
      setInstgramAllPermissions(false);
    }
  }

  const instagramConnect = async () => {
    try {
      const response = await handlesService.instagramConnect();
  
      if (response.status === gtUtil.Constants.SUCCESS) {
        // Open Instagram OAuth in a popup window
        const popup = window.open(
          response.data.url,
          "InstagramOAuthPopup",
          "width=500,height=600,left=100,top=100"
        );
  
        if (!popup) {
          toast.error("Popup blocked. Please allow popups and try again.");
          return;
        }
  
        const channel = new BroadcastChannel('oauth-channel');
        channel.onmessage = async (event) => {
          if (event.data?.type === 'social-auth-success') {
            const authCode = event.data.code;
            channel.close();
  
            try {
              set_social_loader(true);
  
              // Send auth code to backend
              const response = await handlesService.postInstagramConnect({
                code: authCode,
                influencer_id: props?.UserReducer?.influencer_id
              });
  
              if (response.status === gtUtil.Constants.SUCCESS) {
                updateUserReducer();
                set_social_loader(false);
                handleClosePopUps();
                setPopUps({...popUps, openAdditionalSettingsModal: true});
              } else {
                if (response.info === 'Social account already connected to the other account.') {
                  set_ig_data(response.data);
                  set_socialRestrictionPopup(prevState => ({
                    ...prevState,
                    instagram: true
                  }));
                }
              }
            } catch (error) {
              console.error("Error processing Instagram auth response:", error);
              toast.error("Instagram authentication failed.");
            } finally {
              set_social_loader(false);
            }
          }
        };
      } else {
        console.error("Error fetching Instagram OAuth URL:", response.info);
        toast.error("Failed to get Instagram authentication URL.");
      }
    } catch (error) {
      console.error("Instagram Login Error:", error);
      toast.error("Instagram login failed");
    } finally {
      set_social_loader(false);
    }
  };

  useEffect(() => {
    getInfluencerAccounts()
  }, [props.UserReducer.influencer_id])

  return (
    <>
      {isExactToolsPath && (
        <>
          <section className="inf-tools">
            {/* <button className="btn btn-purple" onClick={handleOpenConnectInstagramModal}>Instagram DM Automation</button> */}
            <Link to={'/influencer/tools/ig-dm-automation'} className="btn btn-purple">Instagram DM Automation</Link>
            {/* <button className="btn btn-disabled">Hashtag generator</button>
            <button className="btn btn-disabled">Generate caption</button> */}
            <Link to='javascript:void(0)' className="btn btn-disabled">Hashtag generator</Link>
            <Link to='javascript:void(0)' className="btn btn-disabled">Generate caption</Link>
          </section>
          {/* <Link to={'/influencer/tools/new-automation'} className="mx-2">New Automation</Link>
          <Link to={'/influencer/tools/available-automation'} className="mx-2">Available Automation</Link> */}
        </>
      )}
      <Outlet />
      <CommonPopUpCentered
        centered
        className={`popup-instagram-automation modal-small  mx-auto`}
        openModal={popUps.openConnectInstagram}
        modalTitle="Connect Instagram"
        modalContent=""
        onClose={() => handleClosePopUps()}
      >
        { 
          social_loader 
          ?
          <ContentLoading width='150' height='150' /> 
          :
          <div className="popup-content">
            <p>Automation requires a connected account. Connect your Instagram account and set your permissions to use the feature.</p>
            <button className="btn btn-primary" onClick={instagramConnect}>Connect</button>
          </div>
        }
      </CommonPopUpCentered>
      <CommonPopUpCentered
        centered
        className={`popup-instagram-automation modal-medium  mx-auto`}
        openModal={popUps.openAdditionalSettingsModal}
        modalTitle="Important Instagram Setting"
        modalContent=""
        onClose={() => handleClosePopUps()}
      >
        <div className="popup-content">
          <p className="text-left">It looks like there's one key setting missing from your Instagram account. To enable Automation, please grant access to Instagram Partner messages.</p>
          <div className="text-left">
            <strong>Here’s how to do it:</strong>
            <ol className="">
              <li>Open your Instagram mobile app.</li>
              <li>{`Go to Menu > Settings and activity > Messages and story replies > Message Controls > Connected Tools.`}</li>
              <li>
                {`Toggle ON ‘Allow access to Messages’.`}</li>
            </ol>
          </div>
          <Link onClick={handleClosePopUps} to="/influencer/tools/new-automation" className="btn btn-primary">It’s Done!</Link>
        </div>
      </CommonPopUpCentered>
      <CommonPopUpCentered
        centered
        className={`popup-instagram-automation modal-small  mx-auto`}
        openModal={popUps.openPermissionMissingModal}
        modalTitle="Permissions Missing"
        modalContent=""
        onClose={() => handleClosePopUps()}
      >
        { 
          social_loader 
          ?
          <ContentLoading width='150' height='150' /> 
          :
          <div className="popup-content">
            <p>It looks like a few permissions are missing. Please either reconnect your account or add new one to proceed.</p>          
            <button className="btn btn-primary" onClick={instagramConnect}>Connect</button>
            <p className="mt-4"><strong>Note:</strong> Connecting a new account will disconnect your currently linked account <strong>Account name</strong> and set the new account as your primary account.</p>
          </div>
        }
      </CommonPopUpCentered>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
    updateUser: (data: any) => dispatch(UserLogin(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(InfluencerTools);

export { connectToRedux as InfluencerTools };